<div class="tab-content-pad">
  <div *ngIf="output[0]">
    <ng-container *ngIf="output[0] as c">
      <div class="detail-card">

        <!-- ── Card Header ── -->
        <div class="detail-card-header">
          <div class="employee-identity">
            <img class="employee-avatar" src="assets/img/product.png" alt="Product image">
            <div>
              <p class="employee-name">{{ name }}</p>
              <span class="employee-role-badge">{{ c.product_brand_name || 'Product' }}</span>
            </div>
          </div>
          <a class="btn-edit" (click)="getValue(); EditProducts();">
            <i class="fas fa-pencil-alt"></i> Edit
          </a>
        </div>

        <!-- ── Two-column Fields Grid ── -->
        <div class="detail-fields-grid">

          <div class="detail-field-item full-width">
            <span class="field-label">Product Full Description</span>
            <span class="field-value" [class.empty]="!c.product_full_description">
              {{ c.product_full_description || '—' }}
            </span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">Product SKU</span>
            <span class="field-value" [class.empty]="!c.product_sku">
              {{ c.product_sku || '—' }}
            </span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">Product Brand Name</span>
            <span class="field-value" [class.empty]="!c.product_brand_name">
              {{ c.product_brand_name || '—' }}
            </span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">Product Category Name</span>
            <span class="field-value" [class.empty]="!c.product_category_name">
              {{ c.product_category_name || '—' }}
            </span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">Folder</span>
            <span class="field-value" [class.empty]="!c.folder">
              {{ c.folder || '—' }}
            </span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">Shan's App Folder</span>
            <span class="field-value" [class.empty]="!c.shansapp_folder">
              {{ c.shansapp_folder || '—' }}
            </span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">Product UOM</span>
            <span class="field-value" [class.empty]="!c.product_uom_main">
              {{ c.product_uom_main || '—' }}
            </span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">Product RFID</span>
            <span class="field-value" [class.empty]="!c.rf_id_code">
              {{ c.rf_id_code || '—' }}
            </span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">Product Complaint</span>
            <span class="field-value" [class.empty]="!c.product_complaint_or_out_of_stock">
              {{ c.product_complaint_or_out_of_stock || '—' }}
            </span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">Deviation</span>
            <span class="field-value" [class.empty]="!c.deviation">
              {{ c.deviation || '—' }}
            </span>
          </div>

        </div>

        <!-- ── Prices Section ── -->
        <div class="section-header">
          <i class="fas fa-tag me-2"></i> Pricing
        </div>
        <div class="detail-fields-grid">

          <div class="detail-field-item">
            <span class="field-label">Price Level 1</span>
            <span class="field-value" [class.empty]="!price_level_1">{{ price_level_1 || '—' }}</span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">Test Price</span>
            <span class="field-value" [class.empty]="!test">{{ test || '—' }}</span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">Accounting Price</span>
            <span class="field-value" [class.empty]="!accounting_price">{{ accounting_price || '—' }}</span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">Abudhabi Std Price</span>
            <span class="field-value" [class.empty]="!abudhabi_std_price">{{ abudhabi_std_price || '—' }}</span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">Al Ain Std Price</span>
            <span class="field-value" [class.empty]="!al_ain_std_price">{{ al_ain_std_price || '—' }}</span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">Al Quoz Std Price</span>
            <span class="field-value" [class.empty]="!al_quiz_std_price">{{ al_quiz_std_price || '—' }}</span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">Aweer Std Price</span>
            <span class="field-value" [class.empty]="!aweer_std_price">{{ aweer_std_price || '—' }}</span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">Dip Std Price</span>
            <span class="field-value" [class.empty]="!dip_std_price">{{ dip_std_price || '—' }}</span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">Qusais Std Price</span>
            <span class="field-value" [class.empty]="!qusais_std_price">{{ qusais_std_price || '—' }}</span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">RAK Std Price</span>
            <span class="field-value" [class.empty]="!rak_std_price">{{ rak_std_price || '—' }}</span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">Sajaa Std Price</span>
            <span class="field-value" [class.empty]="!sajaa_std_price">{{ sajaa_std_price || '—' }}</span>
          </div>

          <div class="detail-field-item">
            <span class="field-label">SHJ Std Price</span>
            <span class="field-value" [class.empty]="!shj_std_price">{{ shj_std_price || '—' }}</span>
          </div>

        </div>

        <!-- ── Technical Document ── -->
        <div class="section-header">
          <i class="fas fa-file-alt me-2"></i> Documents
        </div>
        <div class="detail-fields-grid">

          <div class="detail-field-item full-width">
            <span class="field-label">Technical Document</span>
            <div class="doc-row">
              <a [routerLink]="" (click)="goToLink(c.technical_document)" class="doc-link">
                {{ c.technical_document || '—' }}
              </a>
              <div class="doc-actions" *ngIf="btnShown">
                <button class="btn-action" (click)="copyMessage(c.technical_document)">
                  <i class="fas fa-copy"></i> Copy
                </button>
                <button class="btn-action" (click)="Image()">
                  <img class="qr-icon" src="assets/img/Qrcode.png" alt="QR" />
                </button>
              </div>
            </div>
          </div>

          <div class="detail-field-item full-width">
            <span class="field-label">Video Link</span>
            <a [routerLink]="" (click)="goToLink(c.video_link)" class="doc-link">
              {{ c.video_link || '—' }}
            </a>
          </div>

        </div>

        <!-- hidden QR canvas -->
        <canvas id="canvas666" [hidden]="true"></canvas>
        <img src="" alt="" id="image666" />

        <!-- ── Stock Statement ── -->
        <div class="section-header">
          <i class="fas fa-boxes me-2"></i> Stock Statement
        </div>
        <div style="padding: 0 20px 20px;">
          <div class="table-responsive">
            <table class="custom-table">
              <thead>
                <tr>
                  <th>Warehouse Name</th>
                  <th>Warehouse Code</th>
                  <th>Stock</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let d of c.stock_statement">
                  <td>{{ d.warehouse_name }}</td>
                  <td>{{ d.warehouse_code }}</td>
                  <td><strong>{{ d.stock }}</strong></td>
                </tr>
                <tr *ngIf="!c.stock_statement?.length">
                  <td colspan="3" class="text-center text-muted">No stock data available</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- ── Product UOMs ── -->
        <div class="section-header">
          <i class="fas fa-ruler me-2"></i> Product UOMs
        </div>
        <div style="padding: 0 20px 24px;">
          <div class="table-responsive">
            <table class="custom-table">
              <thead>
                <tr>
                  <th>Description</th>
                  <th>UOM Code</th>
                  <th>Factor</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let d of c.product_uoms">
                  <td>{{ d.description }}</td>
                  <td>{{ d.code }}</td>
                  <td>{{ d.factor }}</td>
                </tr>
                <tr *ngIf="!c.product_uoms?.length">
                  <td colspan="3" class="text-center text-muted">No UOM data available</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </ng-container>
  </div>
</div>